var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "backorderList"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('div', {
    staticClass: "col-md-12 mb-2"
  }, [_vm._m(0), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card-actions",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('router-link', {
    staticClass: "btn btn-info px-4",
    attrs: {
      "to": "/dashboard",
      "tag": "button"
    }
  }, [_vm._v("Click Here To Redirect\n          ")])], 1)])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticStyle: {
      "color": "red",
      "text-align": "center",
      "margin-top": "40px"
    }
  }, [_vm._v(" 404 PAGE NOT FOUND")])])
}]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-438438ab", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-438438ab","hasScoped":true}!./src/views/components/invalidurll/invalidurll.component.html
// module id = 985
// module chunks = 0